import { useState, createRef } from 'react';
import clsx from 'clsx';
import useHover from '@/hooks/useHover';

function PartnersApplicationStepBullet({
  step,
  isActive,
  isHover,
}) {
  return (
    <div className="w-12 h-12 flex items-center justify-center">
      <div
        className={clsx(
          'rounded-full border-2 flex items-center justify-center transition ease-in-out duration-300',
          isActive === false && 'w-10 h-10',
          isActive === true && 'w-12 h-12 border-green-500',
          isActive === false && isHover === false && 'border-gray-300',
          isActive === false && isHover === true && 'border-green-500',
        )}
      >
        <div
          className={clsx(
            'rounded-full transition ease-in-out duration-300 flex items-center justify-center',
            isActive === false && 'w-6 h-6',
            isActive === true && 'w-8 h-8 bg-green-500',
            isActive === false && isHover === false && 'bg-gray-300',
            isActive === false && isHover === true && 'bg-green-500',
          )}
        >
          <div
            className={clsx(
              'font-bold text-base',
              isActive === false && 'sr-only',
              isActive === true && 'text-white',
            )}
          >
            {step}
          </div>
        </div>
      </div>
    </div>
  );
}

function PartnersApplicationStep({
  step,
  isActive,
  onClick,
  children,
}) {
  const target = createRef();

  const isHovering = useHover(target);

  return (
    <button ref={target} onClick={onClick} className="relative flex flex-col items-center space-y-4 focus:outline-none px-10 lg:px-12 py-8 lg:py-0" type="button">
      <PartnersApplicationStepBullet step={step} isActive={isActive} isHover={isHovering} />
      <div
        className={clsx(
          'text-base font-medium',
          isActive === false && 'text-gray-600',
          isActive === true && 'text-gray-900',
        )}
      >
        <div className="leading-relaxed">
          {children}
        </div>
      </div>
    </button>
  );
}

export default function PartnersApplicationSteps() {
  const [active, setActive] = useState(0);

  return (
    <div className="flex flex-col">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-10 divide-y-2 lg:divide-y-0 lg:divide-x-2 divide-gray-100">
        <PartnersApplicationStep step={1} isActive={active === 0} onClick={() => setActive(0)}>
          Completa el formulario expresando tu interés en hacerte socio
				</PartnersApplicationStep>
        <PartnersApplicationStep step={2} isActive={active === 1} onClick={() => setActive(1)}>
          Recibimos tu solicitud y la revisamos para tomar una decisión
				</PartnersApplicationStep>
        <PartnersApplicationStep step={3} isActive={active === 2} onClick={() => setActive(2)}>
          Una vez aprobada la solicitud nos comunicamos contigo
				</PartnersApplicationStep>
      </div>
    </div>
  );
}
